import {z} from '@hono/zod-openapi';

export const nissanDiglasCommitSourceParamsSchema = z
  .object({messageId: z.string().uuid().openapi({example: '2e16978f-116a-4ee8-b161-ddd0958a1642'})})
  .openapi('NissanDiglasCommitSourceParams');
